import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";
import React, { useContext } from "react";
import { PropTypes } from "prop-types";

import { useTranslation } from "react-i18next";

import ContentContext from "../../../contexts/ContentContext";

function InternalMediaComment({ isMasterFieldDisabled, masterFieldTooltip }) {
  const { t } = useTranslation("editor-content");
  const { item, onItemUpdate } = useContext(ContentContext);

  const handleChange = (event) => {
    const { value } = event.target;

    const updatedItem = { ...item };

    updatedItem.internal_comment = value;

    onItemUpdate(updatedItem);
  };
  return (
    <div
      className="editor-form-section"
      data-tooltip-id={APP_TOOLTIP_ID}
      data-tooltip-content={masterFieldTooltip}
    >
      <div className="editor-form-section-title">{t("internalComment")}</div>
      <textarea
        rows="5"
        className="internal-comment-input disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed"
        disabled={isMasterFieldDisabled}
        onChange={handleChange}
        value={item.internal_comment}
      />
    </div>
  );
}

InternalMediaComment.propTypes = {
  isMasterFieldDisabled: PropTypes.bool,
  masterFieldTooltip: PropTypes.string,
};

export default InternalMediaComment;
